 
import axios, { AxiosInstance } from 'axios';
import { apiUrl,hash, authTitle } from '../config';

export async function createApiInstance() {
  try {
    

    const apiLink = `${apiUrl}`;
    const authTitle = hash;
    const token = localStorage.getItem(`@${authTitle}:token`);

    const api = axios.create({
      baseURL: apiLink,
    });

    if (token) {
      api.defaults.headers.Authorization = `Bearer ${token}`;
    }

    return api;
  } catch (error) {
    console.error('Failed to create API instance', error);
    return null;
  }
}

